export default "__VITE_ASSET__DYY1hLj$__"